import { RouteLeavingGuard } from '@dreryk/react-components';

import { SentPrescriptionPackage } from '~libs.shared.prescription';

import { draftPrescriptionsTranslationKeys } from '../../../../translations';
import { VisitId } from '../../PrescriptionIssuingPanel.types';

import { DraftPrescriptionsFormController } from './DraftPrescriptionsForm.types';
import { useVisitPrescriptionListDraftUpdateCommand } from './DraftPrescriptionsRouteLeavingGuard.hooks';

type DraftPrescriptionsRouteLeavingGuardProps = Pick<
   DraftPrescriptionsFormController,
   'handleSubmitDraft' | 'formState'
> & {
   readonly visitId: VisitId;
   readonly sentPrescriptionPackages: SentPrescriptionPackage[];
};

export const DraftPrescriptionsRouteLeavingGuard = (props: DraftPrescriptionsRouteLeavingGuardProps): JSX.Element => {
   const { handleSubmitDraft, formState, visitId, sentPrescriptionPackages } = props;
   const { executeAsync: updateDraftPrescriptionsList } = useVisitPrescriptionListDraftUpdateCommand();

   const handleLeave = handleSubmitDraft(async ({ draftPrescriptions, prescriptionCategory }) =>
      updateDraftPrescriptionsList({
         visitId: visitId,
         sentPrescriptionPackages: sentPrescriptionPackages,
         draftPrescriptions: draftPrescriptions,
         prescriptionCategory: prescriptionCategory,
      })
   );

   return (
      <RouteLeavingGuard
         title={draftPrescriptionsTranslationKeys.errorOccurredDuringSavingDraftMessageTitle}
         message={draftPrescriptionsTranslationKeys.errorOccurredDuringSavingDraftMessageMessage}
         active={formState.isDirty}
         onLeave={handleLeave}
         successMessage={draftPrescriptionsTranslationKeys.draftSaved}
         testId={'draftPrescription'}
      />
   );
};
